import script from "./AppFooterSub.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooterSub.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooterSub.vue?vue&type=style&index=0&id=79ae9349&lang=scss"

const __exports__ = script;

export default __exports__